import apiClient from './api-client';

// API Path Constants
const API_BASE = '/masterdata/languages';
const API_PATHS = {
    BASE: API_BASE,
} as const;

export interface Language {
    code: string;
    name: string;
    localeName: string;
    translationProvider: string | null;
}


export const languageService = {
    getSupportedLanguages: async (): Promise<Language[]> => {
        const response = await apiClient.get<{ 
            success: boolean; 
            data: Language[] 
        }>(API_PATHS.BASE);
        return response.data;
    },

    getDefaultLanguage: (): Language => {
        return { code: 'en', name: 'English', localeName: 'English', translationProvider: null };
    },

    isValidLanguageCode: async (code: string): Promise<boolean> => {
        const languages = await languageService.getSupportedLanguages();
        return languages.some(lang => lang.code === code);
    },

    getLanguageByCode: async (code: string): Promise<Language | undefined> => {
        const languages = await languageService.getSupportedLanguages();
        return languages.find(lang => lang.code === code);
    }
}; 